import React from "react";
import { Link, useParams } from "react-router-dom";
import Contact from "../components/Contact";
import { projects } from "../data/projects";
import GridGallery from "../components/GridGallery";

export default function ProjectDetails() {
  const { id } = useParams();
  const project = projects.find((item) => String(item.id) === String(id));

  if (!project) {
    return (
      <main className="min-h-screen pt-32 px-6" dir="rtl">
        <div className="max-w-5xl mx-auto text-right">
          <h1 className="text-3xl text-slate-100 mb-4">הפרויקט לא נמצא</h1>
          <Link to="/projects" className="inline-block text-slate-300 border-b border-slate-500 pb-1">
            חזרה לכל הפרויקטים
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-transparent pt-24">
      <section className="max-w-[1450px] mx-auto px-3 md:px-6 py-6 md:py-10" dir="rtl">
        <div className="text-right mb-10">
          <Link to="/projects" className="inline-block text-slate-300 border-b border-slate-500/80 pb-1 text-sm md:text-base">
            לצפייה בכל הפרויקטים
          </Link>

          <p className="mt-5 text-xs md:text-sm uppercase tracking-[0.24em] text-slate-500">Project</p>

          <h1 className="mt-2 text-3xl md:text-5xl font-light text-slate-100 tracking-tight leading-tight">
            {project.title}
          </h1>

          <p className="mt-2 text-lg md:text-2xl text-slate-300">{project.location}</p>

          <div className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed">
            {project.excerpt ? <p>{project.excerpt}</p> : null}
            {project.summary ? <p className={project.excerpt ? "mt-3" : ""}>{project.summary}</p> : null}
          </div>
        </div>

        <div dir="ltr">
          <GridGallery images={project.images?.length ? project.images : [project.coverImage]} layout="collage" />
        </div>
      </section>

      <Contact />
    </main>
  );
}
